module.exports = __webpack_public_path__ + "img/leeds-united.3fc70f2d.png";